import {gql} from '@apollo/client';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {
  TagSchemaSummariesWithFieldsQuery,
  TagSchemaSummariesWithFieldsQuery_tagSchemas_TagSchemaNode as TagSchemaSummaryWithFields,
} from 'schemas/__generated/TagSchemaSummariesWithFieldsQuery';

export type TagSchemaSummaryWithFieldsGraphQL = TagSchemaSummaryWithFields;

export const TAG_SCHEMA_SUMMARIES_WITH_FIELDS_QUERY = gql`
  query TagSchemaSummariesWithFieldsQuery @skipAudit @engComponent(name: REGISTRY) {
    tagSchemas {
      ...TagSchemaSummaryGraphQL
      fieldsJson
    }
  }
  ${getFragmentWrapper('TagSchemaSummary').fragment}
`;

export function useTagSchemaSummariesWithFields(
  skip?: boolean
): Array<TagSchemaSummaryWithFieldsGraphQL> | null {
  const tagSchemasResult = useSkippableBenchlingQuery<TagSchemaSummariesWithFieldsQuery>(
    TAG_SCHEMA_SUMMARIES_WITH_FIELDS_QUERY,
    {skip: Boolean(skip)}
  );

  if (tagSchemasResult.type !== QueryResultType.SUCCESS) {
    return null;
  } else {
    return tagSchemasResult.data.tagSchemas;
  }
}
